import { BaseContainerModel } from '../base-container.model';
import { bl_wms_warehouse_node_type_item_link_RowInterface, bl_wms_warehouse_node_type_item_link_RowClass } from '../../dbschema/index';

export class WarehouseNodeTypeItemLinkContainer extends BaseContainerModel {
    bl_wms_warehouse_node_type_item_link: bl_wms_warehouse_node_type_item_link_RowInterface = new bl_wms_warehouse_node_type_item_link_RowClass();
}
